import React from 'react';
import { ContainerImg } from './style.css';

const Image = (props) => {
    return ( 
        <ContainerImg
        data-sal="fade"
        data-sal-delay="2000"
        data-sal-easing="ease"
        >
            <img src={props.url} alt="props" />
            <p>{props.name}</p>
            <span>{props.nota}</span>
        </ContainerImg>
     );
}
 
export default Image;